import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent, getHijriToday } from "../lib/api";
import { CalendarDays, Sparkles } from "lucide-react";

export default function Hijri() {
  const { t } = useApp();
  const [today, setToday] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    getHijriToday().then(setToday).catch(() => {});
    getContent("hijri").then(setData);
  }, []);

  const currentMonth = today?.hijri?.month?.number ? data?.months?.find(m => m.num === today.hijri.month.number) : null;
  const dayOfMonth = today?.hijri?.day ? parseInt(today.hijri.day) : null;
  const days = Array.from({ length: 30 }, (_, i) => i + 1);

  return (
    <div className="space-y-6 fade-in" data-testid="hijri-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><CalendarDays className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.hijri}</h1>
          {today && (
            <p className="text-sm text-nour-text2">{today.hijri.day} {today.hijri.month.en} {today.hijri.year} AH · {today.hijri.weekday.en}</p>
          )}
        </div>
      </header>

      {currentMonth && (
        <div className="nour-card p-6 bg-gradient-to-br from-emerald-50 to-emerald-100" data-testid="hijri-month">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-xs uppercase tracking-wider text-nour-text2">{t.today}</div>
              <div className="font-heading text-2xl font-bold text-nour-primary">{currentMonth.name}</div>
              <div className="font-arabic-ui text-xl text-nour-primary" dir="rtl">{currentMonth.ar}</div>
            </div>
            <div className="text-4xl font-extrabold text-nour-primary tabular-nums">{dayOfMonth}</div>
          </div>
          <p className="text-sm text-nour-text2 mt-3">{currentMonth.desc_fr}</p>
        </div>
      )}

      {/* Monthly grid */}
      <div className="nour-card p-4" data-testid="hijri-grid">
        <div className="grid grid-cols-7 gap-2">
          {days.map(d => (
            <div
              key={d}
              className={`aspect-square flex items-center justify-center rounded-lg text-sm font-medium ${
                d === dayOfMonth ? "bg-nour-primary text-white shadow-md" : "bg-emerald-50 text-nour-text"
              }`}
            >{d}</div>
          ))}
        </div>
      </div>

      <h2 className="font-heading text-xl font-bold pt-2">Événements islamiques</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="hijri-events">
        {data?.events?.map(e => (
          <div key={e.id} className="nour-card p-4 flex gap-3" data-testid={`event-${e.id}`}>
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
              <Sparkles className="w-4 h-4 text-nour-primary" />
            </div>
            <div>
              <div className="font-semibold">{e.name_fr}</div>
              <div className="font-arabic-ui text-nour-primary text-sm" dir="rtl">{e.name_ar}</div>
              <div className="text-xs text-nour-text2 mt-1">{e.desc_fr}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
